(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("classnames"), require("immutable"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "classnames", "immutable"], factory);
	else if(typeof exports === 'object')
		exports["Checkbox"] = factory(require("react"), require("prop-types"), require("classnames"), require("immutable"));
	else
		root["r"] = root["r"] || {}, root["r"]["m"] = root["r"]["m"] || {}, root["r"]["m"]["Checkbox"] = factory(root["_"], root["_"], root["_"], root["_"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition